import {
	mdiAccountGroup,
	mdiAccountSearch,
	mdiBriefcaseOutline,
	mdiCalculator,
	mdiAccountSupervisor,
	mdiAccountVoice,
	mdiBellOutline,
	mdiCalendar,
	mdiCardAccountDetailsOutline,
	mdiCogOutline,
	mdiCurrencyUsd,
	mdiFileDocumentEditOutline,
	mdiFlag,
	mdiTagMultipleOutline,
	mdiFileDocumentMultipleOutline,
	mdiFilterVariant,
	mdiHumanQueue,
	mdiGamepadSquare,
	mdiHammerWrench,
	mdiHandshakeOutline,
	mdiHome,
	mdiImageAlbum,
	mdiKeyVariant,
	mdiMessage,
	mdiNewspaperVariantMultipleOutline,
	mdiPaletteOutline,
	mdiTextBoxCheck,
	mdiViewCompact,
	mdiMicrophone,
	mdiSteam,
	mdiTrophy,
	mdiVideoOutline,
	mdiViewGridOutline,
	mdiQrcodeScan,
} from '@mdi/js'

// Array of sections

export default [
	{
		icon: mdiHome,
		title: 'Dashboard',
		to: 'agency-dashboard',
	},
	{
		icon: mdiBriefcaseOutline,
		title: 'agency.campaignDetail.campaigns',
		to: 'agency-campaign-orders-list',
		module: 'MGAG',
	},
	{
		icon: mdiHandshakeOutline,
		title: 'menu.agency.programs',
		to: 'agency-programs-list',
		module: 'MGAG',
	},
	{
		icon: mdiQrcodeScan,
		title: 'menu.agency.fieldActivations',
		to: 'agency-field-activations-list',
		module: 'MGAG',
	},
	{
		title: 'Marketing',
		icon: mdiViewCompact,
		module: 'MGAG,marketing',
		children: [
			{
				title: 'Community',
				children: [
					{
						title: 'menu.community.feedPromotions',
						to: 'agency-feed-promotions',
					},
				],
			},
			{
				title: 'menu.agency.marketing.cases',
				children: [
					{
						title: 'menu.agency.marketing.cases',
						to: 'agency-marketing-cases-list',
					},
					{
						title: 'menu.agency.marketing.casesTypes',
						to: 'agency-marketing-cases-types-list',
					},
				],
			},
			{
				title: 'menu.agency.marketing.campaigns',
				children: [
					{
						title: 'menu.agency.marketing.campaigns',
						to: 'agency-marketing-campaigns-list',
					},
					{
						title: 'menu.networkMarketingCampaignsBanners',
						to: 'agency-marketing-campaigns-banners-list',
					},
					{
						title: 'menu.agency.marketing.bannerArtwork',
						to: 'agency-marketing-banner-artwork',
					},
					{
						title: 'menu.agency.marketing.bannerModeration',
						to: 'agency-marketing-banner-moderation',
					},
					{
						title: 'menu.agency.marketing.campaignsCategories',
						to: 'agency-marketing-campaigns-categories-list',
					},
					{
						title: 'menu.agency.marketing.campaignsTypes',
						to: 'agency-marketing-campaigns-types-list',
					},
				],
			},
			{
				title: 'menu.agency.marketing.ads',
				children: [
					{
						title: 'menu.agency.marketing.adChannels',
						to: 'agency-marketing-ad-channels-list',
					},
					{
						title: 'menu.agency.marketing.adFormats',
						to: 'agency-marketing-ad-formats-list',
					},
					{
						title: 'menu.agency.marketing.adSizes',
						to: 'agency-marketing-ad-sizes-list',
					},
					{
						title: 'menu.agency.marketing.adTypes',
						to: 'agency-marketing-ad-types-list',
					},
				],
			},
			{
				title: 'KPI',
				children: [
					{
						title: 'menu.agency.marketing.kpiGroups',
						to: 'agency-marketing-kpi-groups-list',
					},
					{
						title: 'menu.agency.marketing.kpiOptions',
						to: 'agency-marketing-kpi-options-list',
					},
				],
			},
			{
				title: 'ageRanges',
				to: 'agency-marketing-age-ranges-list',
			},
			{
				title: 'brands',
				to: 'agency-marketing-brands-list',
			},
			{
				title: 'genderDominances',
				to: 'agency-marketing-gender-dominances-list',
			},
			{
				title: 'niches',
				to: 'agency-marketing-niches-list',
			},
			{
				title: 'menu.agency.marketing.presentations',
				to: 'agency-marketing-presentations-list',
			},
			{
				title: 'menu.agency.marketing.providers',
				to: 'agency-marketing-providers-list',
			},
			{
				title: 'styleContent',
				to: 'agency-marketing-content-styles-list',
			},
			{
				title: 'tiers',
				to: 'agency-marketing-tiers-list',
			},
			{
				title: 'trackingPlatforms',
				to: 'agency-marketing-tracking-platforms-list',
			},
		],
	},
	{
		title: 'menu.magazines.title',
		icon: mdiImageAlbum,
		module: 'MGAG,magazines',
		children: [
			{
				title: 'menu.magazines.title',
				to: 'agency-magazine-list',
			},
			{
				title: 'menu.magazines.sections',
				to: 'agency-magazine-sections-list',
			},
		],
	},
	{
		title: 'Mundo Indie',
		icon: mdiGamepadSquare,
		module: 'MGAG,mundo-indie',
		children: [
			{
				title: 'Indie Walls',
				to: 'agency-walls-list',
				icon: mdiViewGridOutline,
			},
			{
				title: 'menu.agency.goals',
				to: 'agency-goals-list',
			},
			{
				title: 'menu.agency.projects',
				to: 'agency-projects-list',
			},
			{
				title: 'menu.agency.game',
				to: 'agency-game-status-list',
			},
			{
				title: 'menu.agency.testimonials',
				to: 'agency-testimonials-list',
			},
			{
				title: 'menu.agency.workflow',
				to: 'agency-workflow-status-list',
			},
		],
	},
	{
		icon: mdiMicrophone,
		title: 'menu.podcasts.title',
		module: 'MGAG,podcasts',
		children: [
			{
				title: 'menu.podcasts.shows',
				to: 'agency-podcasts-shows-list',
			},
			{
				title: 'menu.podcasts.episodes',
				to: 'agency-podcasts-episodes-list',
			},
			{
				title: 'menu.podcasts.guests',
				to: 'agency-podcasts-guests-list',
			},
			{
				title: 'menu.podcasts.hosts',
				to: 'agency-podcasts-hosts-list',
			},
			{
				title: 'menu.podcasts.sponsors',
				to: 'agency-podcasts-sponsors-list',
			},
			{
				title: 'menu.podcasts.consents',
				to: 'agency-podcasts-consents-list',
			},
			{
				title: 'menu.podcasts.slots',
				to: 'agency-podcasts-slots-list',
			},
			{
				title: 'menu.podcasts.calendar',
				to: 'agency-podcasts-calendar',
			},
		],
	},
	{
		title: 'menu.agency.keys',
		icon: mdiKeyVariant,
		module: 'MGAG,keys',
		children: [
			{
				title: 'menu.agency.keys',
				to: 'agency-keys-list',
			},
			{
				title: 'menu.agency.keysContents',
				to: 'agency-keys-contents-list',
			},
			{
				title: 'menu.agency.keysRequests',
				to: 'agency-keys-requests-list',
			},
			{
				title: 'menu.agency.keysMaterials',
				to: 'agency-keys-materials-global',
			},
			{
				title: 'menu.agency.keysRequestsStatus',
				to: 'agency-keys-requests-status-list',
			},
			{
				title: 'menu.agency.keysTypes',
				to: 'agency-keys-types-list',
			},
			{
				title: 'menu.agency.keysStatus',
				to: 'agency-keys-status-list',
			},
			{
				title: 'menu.agency.keysSuppliers',
				to: 'agency-keys-suppliers-list',
			},
			{
				title: 'menu.agency.keysSuppliersPrs',
				to: 'agency-keys-suppliers-prs-list',
			},
			{
				title: 'menu.mailHubKeyRequestsStudio',
				to: 'agency-keys-ask-studio',
			},
		],
	},
	{
		title: 'menu.agency.showcases',
		icon: mdiCalendar,
		module: 'MGAG,showcases',
		children: [
			{
				title: 'Private Showcase invitations',
				to: 'agency-showcase-private-invites',
			},
			{
				title: 'menu.agency.showcasesCoverages',
				to: 'agency-showcases-coverages-list',
			},
			{
				title: 'menu.agency.showcases',
				to: 'agency-showcases-list',
			},
			{
				title: 'menu.agency.showcasesSubmissions',
				to: 'agency-showcases-submissions-list',
			},
			{
				title: 'menu.agency.showcaseDeliverables',
				to: 'agency-showcase-deliverables-list',
			},
			{
				title: 'menu.agency.showcasesCoverageSourceTypes',
				to: 'agency-coverage-source-types-list',
			},
			{
				title: 'menu.agency.showcasesCoverageFeedSources',
				to: 'agency-coverage-feed-sources-list',
			},
			{
				title: 'menu.agency.showcasesMediaPartnerApplications',
				to: 'agency-showcase-media-partner-applications-list',
			},
			{
				title: 'menu.agency.showcasesCoverageSubmissions',
				to: 'agency-showcase-coverage-submissions-list',
			},
			{
				title: 'menu.agency.showcasesCoverageSuggestions',
				to: 'agency-showcase-coverage-suggestions-list',
			},
			{
				title: 'menu.agency.coveragesBulkImport',
				to: 'agency-showcases-coverages-bulk-import',
			},
			{
				title: 'menu.agency.showcasesSponsorApplications',
				to: 'agency-showcase-sponsor-applications-list',
			},
			{
				title: 'menu.agency.pressRoomKeyRequests',
				to: 'agency-press-room-key-requests-list',
			},
		],
	},
	{
		title: 'menu.agency.studioOutreach',
		icon: mdiSteam,
		module: 'MGAG,showcases',
		children: [
			{
				title: 'menu.agency.studioProspects',
				to: 'agency-studio-prospects-list',
			},
			{
				title: 'menu.agency.studioProspectsBoard',
				to: 'agency-studio-prospects-board',
			},
			{
				title: 'menu.agency.commercialAccountsWorklist',
				to: 'agency-commercial-accounts-worklist',
			},
			{
				title: 'menu.agency.commercialAccountsList',
				to: 'agency-commercial-accounts-list',
			},
			{
				title: 'menu.agency.commercialAccountsBoard',
				to: 'agency-commercial-accounts-board',
			},
			{
				title: 'menu.agency.commercialAccountsConversion',
				to: 'agency-commercial-accounts-conversion',
			},
			{
				title: 'menu.agency.studioProspectSourceReviews',
				to: 'agency-studio-prospect-source-reviews',
			},
			{
				title: 'menu.agency.commercialAccountOpportunities',
				to: 'agency-commercial-account-opportunities',
			},
			{
				title: 'menu.agency.prospectEmailTemplates',
				to: 'agency-prospect-email-templates-list',
			},
			{
				title: 'menu.agency.studioOnboardingInvites',
				to: 'agency-studio-onboarding-invites',
			},
			{
				title: 'menu.agency.studioOnboardingQuestions',
				to: 'agency-studio-onboarding-questions',
			},
			{
				title: 'menu.agency.studioOnboardingSubmissions',
				to: 'agency-studio-onboarding-submissions',
			},
			{
				title: 'menu.agency.studioOnboardingFollowups',
				to: 'agency-studio-onboarding-followups',
			},
		],
	},
	{
		title: 'menu.agency.pressRelease',
		icon: mdiFileDocumentEditOutline,
		module: 'MGAG,press-release',
		children: [
			{
				title: 'menu.agency.pressReleaseTemplates',
				to: 'agency-press-releases-templates',
			},
			{
				title: 'menu.agency.pressReleaseCampaigns',
				to: 'agency-pr-campaigns-list',
			},
			{
				title: 'menu.agency.pressReleaseCalendar',
				to: 'agency-pr-campaigns-calendar',
			},
			{
				title: 'menu.agency.pressReleaseUnsubscribeReasons',
				to: 'agency-pr-unsubscribe-reasons',
			},
			{
				title: 'menu.agency.pressReleaseProfessionalLeads',
				to: 'agency-pr-assignments-leads',
			},
			{
				title: 'menu.agency.pressReleaseProfessionalBoard',
				to: 'agency-pr-assignments-board',
			},
			{
				title: 'agency.pressRelease.briefings.title',
				to: 'agency-briefings-list',
			},
		],
	},
	{
		title: 'menu.agency.pressReleaseFunnels',
		icon: mdiFilterVariant,
		module: 'MGAG,press-release',
		children: [
			{
				title: 'menu.agency.pressReleaseFunnelsList',
				to: 'agency-pr-funnels-list',
			},
		],
	},
	{
		title: 'Press & Media',
		icon: mdiNewspaperVariantMultipleOutline,
		module: 'MGAG,press-media',
		children: [
			{
				title: 'Press Database',
				to: 'agency-journalists-list',
			},
			{
				title: 'Import Contacts',
				to: 'agency-journalist-import',
			},
		],
	},
	{
		icon: mdiAccountGroup,
		title: 'menu.agency.influencers',
		to: 'agency-influencers-list',
		module: 'MGAG,influencers',
	},
	{
		// Top-level rather than nested under Showcases: this is a standalone
		// product any studio can use without being enrolled in an event.
		icon: mdiVideoOutline,
		title: 'menu.agency.videoSubmissions',
		to: 'agency-video-submissions-list',
		module: 'MGAG,marketing',
	},
	{
		icon: mdiCalculator,
		title: 'menu.agency.budgetBuilder',
		to: 'agency-budget-builder',
		module: 'MGAG,influencers',
	},
	{
		icon: mdiHumanQueue,
		title: 'agency.creatorHub.title',
		module: 'MGAG,creator-hub',
		children: [
			{
				title: 'agency.roster.title',
				to: 'agency-campaign-rosters-list',
			},
			{
				title: 'agency.paymentOrders.title',
				to: 'agency-payment-orders-list',
			},
			{
				icon: mdiAccountSearch,
				title: 'agency.prospects.title',
				to: 'agency-casting-prospects-list',
			},
			{
				icon: mdiCogOutline,
				title: 'agency.settings.title',
				to: 'agency-settings',
			},
		],
	},
	{
		icon: mdiMessage,
		title: 'menu.messages',
		to: 'agency-messages-list',
		module: 'MGAG,messages',
	},
	{
		icon: mdiAccountVoice,
		title: 'menu.agency.contactMessages',
		to: 'contact-requests-list',
	},
	{
		icon: mdiAccountSupervisor,
		title: 'menu.agency.requestMessages',
		to: 'requests-list',
	},
	{
		title: 'Newsletter',
		icon: mdiNewspaperVariantMultipleOutline,
		module: 'MGAG,newsletter',
		children: [
			{
				title: 'Newsletter',
				to: 'agency-newsletter-list',
			},
			{
				title: 'menu.agency.newsletter.campaigns',
				to: 'agency-newsletter-campaigns-list',
			},
			{
				title: 'menu.agency.newsletter.categories',
				to: 'agency-newsletter-categories-list',
			},
			{
				title: 'menu.agency.newsletter.periodicities',
				to: 'agency-newsletter-periodicities-list',
			},
		],
	},
	{
		title: 'menu.agency.services',
		icon: mdiHammerWrench,
		module: 'MGAG,services',
		children: [
			{
				title: 'menu.agency.services',
				to: 'agency-services-list',
			},
			{
				title: 'menu.agency.categories',
				to: 'services-categories-list',
			},
			{
				title: 'menu.agency.audience',
				to: 'agency-target-audiences-list',
			},
		],
	},
	{
		title: 'menu.themes.themes',
		icon: mdiPaletteOutline,
		children: [
			{
				title: 'menu.themes.appThemes',
				to: 'app-themes-list',
			},
			{
				title: 'menu.themes.projectsVariables',
				to: 'projects-variables-list',
			},
		],
	},
	{
		icon: mdiTextBoxCheck,
		title: 'menu.agency.userTestimonials',
		children: [
			{
				title: 'menu.agency.userTestimonials',
				to: 'agency-user-testimonials-list',
			},
			{
				title: 'agency.testimonialInitiatives.title',
				to: 'agency-testimonial-initiatives-list',
			},
			{
				title: 'agency.testimonialRequests.title',
				to: 'agency-testimonial-requests-list',
			},
		],
	},
	{
		icon: mdiTrophy,
		title: 'menu.agency.wallOfLegends',
		to: 'agency-wall-of-legends-list',
		module: 'MGAG,wall-of-legends',
	},
	{
		icon: mdiFileDocumentEditOutline,
		title: 'agency.documents.title',
		module: 'MGAG',
		children: [
			{
				title: 'agency.contractTemplates.title',
				to: 'agency-contract-templates-list',
			},
			{
				title: 'agency.contracts.title',
				to: 'agency-contracts-list',
			},
			{
				title: 'esignature.title',
				to: 'agency-electronic-signatures',
			},
		],
	},
	{
		icon: mdiFileDocumentMultipleOutline,
		title: 'menu.agency.pressKits',
		module: 'MGAG,press-kits',
		children: [
			{ title: 'menu.agency.pressKitsList', to: 'agency-press-kits-list' },
		],
	},
	{
		icon: mdiCardAccountDetailsOutline,
		title: 'menu.agency.mediaKits',
		module: 'MGAG,media-kits',
		children: [
			{ title: 'menu.agency.mediaKitsList', to: 'agency-media-kits-list' },
		],
	},
	{
		icon: mdiBellOutline,
		title: 'notifications.notifications',
		module: 'MGAG,notifications',
		children: [
			{
				title: 'menu.notifications.list',
				to: 'agency-notifications-list',
			},
			{
				title: 'menu.notifications.templates',
				to: 'network-notification-templates-list',
			},
		],
	},
	{
		icon: mdiCurrencyUsd,
		title: 'agency.proposalsModeration.title',
		to: 'agency-proposals-list',
		module: 'MGAG,press-release',
	},
	{
		icon: mdiTextBoxCheck,
		title: 'agency.reviewsModeration.title',
		to: 'agency-reviews-list',
		module: 'MGAG,press-release',
	},
	{
		icon: mdiFlag,
		title: 'agency.reports.title',
		module: 'MGAG,press-release',
		to: 'agency-reports-list',
	},
	{
		icon: mdiTagMultipleOutline,
		title: 'agency.reportCategories.title',
		module: 'MGAG,press-release',
		to: 'agency-reports-categories',
	},
]
